import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';

const Profile: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="px-4 py-6">
          <h1 className="text-2xl font-serif text-gray-900">Profile</h1>
        </div>
      </header>

      {/* Profile Info */}
      <div className="px-4 py-6">
        <div className="bg-white rounded-lg shadow-sm p-6 space-y-4">
          <div>
            <label className="text-sm text-gray-500">Name</label>
            <p className="text-lg font-medium text-gray-900">{user?.name}</p>
          </div>
          
          <div>
            <label className="text-sm text-gray-500">Email</label>
            <p className="text-lg font-medium text-gray-900">{user?.email}</p>
          </div>
          
          <div>
            <label className="text-sm text-gray-500">Access Level</label>
            <p className="text-lg font-medium text-gray-900">
              {user?.catalogAccessLevel === 'exclusive'
                ? 'Exclusive Access'
                : user?.catalogAccessLevel === 'partner'
                ? 'Partner Access'
                : user?.catalogAccessLevel === 'paid_deposit'
                ? 'Paid Deposit Access'
                : 'New Member Access'}
            </p>
            {user?.catalogAccessLevel !== 'exclusive' && user?.catalogAccessLevel !== 'partner' && (
              <p className="text-sm text-gray-600 mt-1">
                Contact our store to upgrade your access level
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="px-4 pb-6">
        <button
          onClick={handleLogout}
          className="w-full bg-white rounded-lg shadow-sm p-4 flex items-center justify-between hover:shadow-md transition-shadow"
        >
          <span className="text-gray-900 font-medium">Log Out</span>
          <ArrowRightOnRectangleIcon className="h-5 w-5 text-gray-400" />
        </button>
      </div>
    </div>
  );
};

export default Profile;